/** 字靈收服 · 核心型別。一張「字卡」= 一個關鍵實詞／虛詞；每張卡掛著若干道從課文、真題出的題。 */

export type Tier = "N" | "R" | "SR" | "SSR";
export type QType = "gloss" | "usage" | "exam" | "pair" | "same";

export interface Book {
  id: string;
  label: string;
  glyph: string;
  region: "cn" | "tw";
  stage: string;
  cards: number;
  questions: number;
}

export interface Lesson {
  /** 選文關卡（見 rank.ts LessonLite.bonus） */
  bonus?: boolean;
  /** 真題試卷關（龍門貢院） */
  exam?: boolean;
  id: string;
  title: string;
  author: string;
  books: string[];
  questions: number;
}

export interface CardMeta {
  id: string;
  w: string;
  key: string;
  py: string;
  kind: "function" | "content";
  tier: Tier;
  score: number;
  senses: string[];
  lists: string[];
  books: string[];
  regions: string[];
  sw: { bu: string; text: string; note: string } | null;
  dictUrl: string;
  n: number;
}

/** [id, cardIndex, typeCode, chunk, booksMask, diff100, lessonId] */
export type QIndex = [string, number, number, string, number, number, string];

export interface BankMeta {
  builtAt: string;
  edition: string;
  v: string;
  books: Book[];
  lessons: Lesson[];
  cards: CardMeta[];
  qi: QIndex[];
  /** 退役題 id（2026-11-03 起；答對過的仍計題海加成） */
  retired?: string[];
  stats: Record<string, unknown>;
}

export interface Source {
  label: string;
  url?: string;
  role: string;
  note?: string;
}

export interface Question {
  id: string;
  c: string;
  t: QType;
  stem: string;
  s: string;
  opts: string[]; // opts[0] is always the correct one (shuffle at render time)
  why: string;
  src: { label: string; title: string; book: string; author?: string; year?: number };
  sources: Source[];
  diff: number;
  region: string;
  book: string;
}

export const TYPE_NAMES: Record<number, QType> = { 0: "gloss", 1: "usage", 2: "exam", 3: "pair", 4: "same" };
export const TYPE_LABEL: Record<QType, string> = { gloss: "釋義", usage: "用法", exam: "真題", pair: "辨義", same: "同義辨" };
export const TIER_LABEL: Record<Tier, string> = { N: "常見", R: "稀有", SR: "史詩", SSR: "傳說" };

export type RunMode = "daily" | "free" | "wrong" | "lesson";

export interface RunAnswer {
  q: string;
  pick: string; // option text chosen ("" when timed out)
  ms: number;
  correct: boolean;
  score: number;
  combo: number;
}

export interface RunSummary {
  mode: RunMode;
  seed: string;
  scope: string;
  startedAt: number;
  finishedAt: number;
  answers: RunAnswer[];
  score: number;
  correct: number;
  total: number;
  maxCombo: number;
  newCards: string[];
  lost: boolean; // 燭火燃盡敗退
}
